import { FC, useEffect, useRef } from "react";
import { Formik, FormikProps } from "formik";
import { FormControl } from "./Fields";
import { DynamicFormStateType } from ".";
import st from "./DynamicForm.module.scss";

interface IRootFormProps {
	formState: DynamicFormStateType;
	readOnly?: boolean;
	onChangeValue?: ( fieldPath: string, value: any ) => void;
	pageIndex?: number;
};

const RootForm: FC<IRootFormProps> = ( props ) => {

	const { formState, onChangeValue, readOnly = false, pageIndex = 0 } = props;
	const formikRef = useRef<FormikProps<any>>(null);

	useEffect( () => {
		if ( formState?.rootModel?.mediator )
			formState.rootModel.mediator.onSetValue = onChangeValueInner;
	// eslint-disable-next-line
	}, [] );

	useEffect( () => {
		if ( formState?.rootModel?.mediator?.setCurrentPageIndex ) {
			formState.rootModel.mediator.setCurrentPageIndex( pageIndex );
		}
	}, [ pageIndex, formState?.rootModel ] );

	/**
	 * Вызывается при изменении значений из скрипта
	 * @param fieldPath Наименование поля
	 * @param value Значение
	 */
	function onChangeValueInner ( fieldPath: string, value: any ) {
		if ( !!formikRef.current ) {
			formikRef.current.setFieldValue( fieldPath, value );
		}
		if ( onChangeValue ) {
			onChangeValue( fieldPath, value );
		}
	};

	/**
	 * Вызывается для установки значения поля из формы
	 * @param fieldPath Наименование поля
	 * @param value Значение
	 */
	const onSetValueHandler = ( fieldPath: string, value: any ) => {
		if ( !!formikRef.current ) {
			formikRef.current.setFieldValue( fieldPath, value );
		}
		setTimeout(() => {
			formState?.rootModel?.mediator.changeValue( fieldPath, value );
		} );
		
		if ( onChangeValue ) {
			onChangeValue( fieldPath, value );
		}
	};

	return (
		<Formik initialValues={formState.data} innerRef={formikRef} validateOnChange={true} onSubmit={ () => {} }>
			<form id="DF" className={st.form}>
				{
					( formState?.loaded && !!formState?.rootModel ) &&
					<FormControl
						model={formState?.rootModel} 
						readOnly={ !formState?.rootModel.ControlEnabling || readOnly }
						setFieldValue={onSetValueHandler}
						pageIndex={pageIndex}
					/>
				}
			</form>
		</Formik>
	);
};

export default RootForm;
